import { render } from "./SalesProductList.vue?vue&type=template&id=075216c3&scoped=true"
import script from "./SalesProductList.vue?vue&type=script&lang=js"
export * from "./SalesProductList.vue?vue&type=script&lang=js"

import "./SalesProductList.vue?vue&type=style&index=0&id=075216c3&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075216c3"]])

export default __exports__